import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import {
  ACCESS_TOKEN,
  REQUEST_HEADER_AUTH_KEY,
  TOKEN_TYPE,
} from "utils/constant";

class APIService {
  baseApi!: AxiosInstance;
  init() {
    this.baseApi = axios.create({
      // baseURL: "http://127.0.0.1:8000/api/",
      baseURL: "https://kangrooapi-eso9i.ondigitalocean.app/api/",
    });

    this.baseApi.interceptors.request.use(
      async (config) => {
        const accessToken = await localStorage.getItem(ACCESS_TOKEN);
        if (accessToken) {
          config.headers[
            REQUEST_HEADER_AUTH_KEY
          ] = `${TOKEN_TYPE}${accessToken}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    this.baseApi.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response && error.response.status === 404) {
          // localStorage.clear();
          // window.location.href = "/";
        }
        return Promise.reject(error);
      }
    );
  }

  fetchData(param: AxiosRequestConfig = {}) {
    return new Promise<any>((resolve, reject) => {
      this.baseApi(param)
        .then((response) => {
          resolve(response.data);
        })
        .catch((errors) => {
          reject(errors);
        });
    });
  }
}
const apiService = new APIService();
export default apiService;
